var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-placeholders',{staticClass:"wc-loaders-heading-avatar flex-fill",class:_vm.styleClass,attrs:{"rounded":true}},[_c('content-placeholders-heading',{attrs:{"img":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }